import IntersectionRenderer from './IntersectionRenderer';
import { useFlag } from '@/features/unleash';
import { getLocationPathname } from '@/redux/location/selectors';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';

type Props = {
  children: ReactNode;
};

const ReportSubSectionVirtualizedContent = ({ children }: Props) => {
  const flag = useFlag({ name: 'mono-report-virtualized-sections' });
  const pathname = useSelector(getLocationPathname);
  const isUsMarket = pathname.startsWith('/stocks/us/');
  const isVirtualizationEnabled = flag.flagsReady && flag.enabled && isUsMarket;

  if (isVirtualizationEnabled)
    return <IntersectionRenderer>{children}</IntersectionRenderer>;

  return <>{children}</>;
};

export default ReportSubSectionVirtualizedContent;
